var map = {
	"./appAsset--alerts-ax.svg": "2a1c",
	"./appAsset--branch-ax.svg": "6bf8",
	"./appAsset--certificate-ax.svg": "c1e2",
	"./appAsset--create-ax.svg": "65a4",
	"./appAsset--customer-address-ax.svg": "3f1b",
	"./appAsset--customer-contact-ax.svg": "e207",
	"./appAsset--customer-econ-ax.svg": "5fbe",
	"./appAsset--documents-ax.svg": "9caf",
	"./appAsset--groups-ax.svg": "0a59",
	"./appAsset--log-ax.svg": "64cf",
	"./appAsset--organization-ax.svg": "6b6f",
	"./appAsset--pdf-ax.svg": "b916",
	"./appAsset--pos-ax.svg": "f3b1",
	"./appAsset--product-ax.svg": "69d0",
	"./appAsset--purchase-ax.svg": "8c99",
	"./appAsset--suppliers-ax.svg": "1996",
	"./appAsset--tracker-ax.svg": "7999",
	"./appAsset--webhooks-ax.svg": "69ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "be98";